




























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import Card from '@/stories/utils/card.vue'


@Component({
  components: {
    Card,
  }
})
export default class StorybookCreateUrlTags extends Vue {
  get chips() {
    return [
      {
        tag: 'tag1',
        disabled: false
      },
      {
        tag: 'tag2',
        disabled: true
      },
      {
        tag: 'tag3',
        disabled: false
      }
    ]
  }
}
